import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
	providedIn: 'root',
})
export class CryptoService {
	private skey = '_]0#2sç2oGyRq!T';
	private b64key = 'bXlfc2VjcmV0XyFAQCojJipAJiM=';
	constructor() {}

	encryptAES(value: string): string {
		return CryptoJS.AES.encrypt(value, this.skey).toString();
	}

	decryptAES(textToDecrypt: string) {
		return CryptoJS.AES.decrypt(textToDecrypt, this.skey).toString(CryptoJS.enc.Utf8);
	}

	encryptB64(value: string): string {
		return CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(value));
	}

	decryptB64(value: string): string {
		return CryptoJS.enc.Base64.parse(value).toString(CryptoJS.enc.Utf8);
	}

	fuseB64Key(b64string: string): string {
		return b64string + this.b64key;
	}

	hashCode(string_: string) {
		let hash = 0;
		for (let index = 0; index < string_.length; index++) {
			hash = (hash << 5) - hash + string_.charCodeAt(index);
			hash = Math.trunc(hash); // Convert to 32bit integer
		}
		return hash;
	}

	hashCodeHex(string_: string) {
		const hash = this.hashCode(string_);
		return (hash >>> 0).toString(16);
	}
}
